import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const cseButtonRow = {
  columnGap: css`var(--cse-button-row-column-gap, ${csSpacing.spacing06})`,
  rowGap: css`var(--cse-button-row-row-gap, var(--cse-button-row-gap, ${csSpacing.spacing06}))`
}

export const style: CSSResult = css`
  .cse-button-row {
    column-gap: ${cseButtonRow.columnGap};
    display: flex;
    flex-wrap: wrap;
    row-gap: ${cseButtonRow.rowGap};
  }
`
